// Task 7.5: Analytics Provider with Consent Management

'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  initializeAnalytics,
  initializePosthog,
  syncPosthogSessionRecording,
  trackCurrentPageView,
} from '@/lib/analytics';

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    // Initialize analytics with default denied consent
    initializeAnalytics();
    initializePosthog();
    
    // Listen for consent updates
    const handleConsentUpdate = () => {
      // Reinitialize analytics with updated consent
      initializeAnalytics();
      initializePosthog();
      trackCurrentPageView();
    };
    
    window.addEventListener('consent-updated', handleConsentUpdate);
    return () => window.removeEventListener('consent-updated', handleConsentUpdate);
  }, []);

  useEffect(() => {
    syncPosthogSessionRecording();
  }, [pathname]);

  return <>{children}</>;
}
